/* eslint-disable @typescript-eslint/no-unused-vars */
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';
import { Subscription } from '@price-card/models/subscription.model';
import {
  retrievePriceCardSubscriptionsFailure,
  retrievePriceCardSubscriptionsSuccess,
} from '@store/price-card/subscription/subscription.slice';

export const retrievePriceCardSubscriptionsEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
)=>
  action$.pipe(
    ofType('price-card-subscriptions/retrievePriceCardSubscriptions'),
    concatMap((_action: Action) =>
      from(dependencies.priceCardSubscriptionGateway.retrieveAll()).pipe(
        map((subscriptions: Subscription[]) => retrievePriceCardSubscriptionsSuccess(subscriptions)),
        catchError(() =>
          of(retrievePriceCardSubscriptionsFailure('Failed to retrieve subscriptions')),
        ),
      ),
    ),
  );
